import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import {
    FlightZoneApplicationPurpose,
    FlightZoneSelectOption,
    GeneralAviationRestrictionExclusions,
    RestrictionExclusions,
} from "../../../models/flight-zone-shared.models";

interface GeneralAviationExclusionsSummaryComponentState {
    restrictionExclusions: GeneralAviationRestrictionExclusions | undefined;
}

@Component({
    selector: "dss-shared-lib-general-aviation-exclusions-summary[restrictionExclusions]",
    templateUrl: "./general-aviation-exclusions-summary.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class GeneralAviationExclusionsSummaryComponent {
    public readonly restrictionExclusions$ = this.localStore.selectByKey("restrictionExclusions");

    @Input() public set restrictionExclusions(value: RestrictionExclusions | undefined) {
        if (value?.purpose !== FlightZoneApplicationPurpose.ForbiddingUAVAndGeneralAviationFlights) {
            return;
        }

        this.localStore.patchState({ restrictionExclusions: value });
    }

    constructor(private readonly localStore: LocalComponentStore<GeneralAviationExclusionsSummaryComponentState>) {
        this.localStore.setState({
            restrictionExclusions: undefined,
        });
    }

    public formatCoursesToDisplay(courses: FlightZoneSelectOption<string>[]): string {
        return courses.map((course) => course.title).join(", ");
    }
}
